"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_FILE_NAME_MAX_LENGTH = exports.VIDEO_DESCRIPTION_MAX_LENGTH = exports.SupportedHubLVideoParams = exports.DefaultHubLVideoParams = void 0;
var DefaultHubLVideoParams = {
  overrideable: false,
  type: 'scriptV4',
  hide_playlist: true,
  viral_sharing: false,
  embed_button: false,
  autoplay: false,
  hidden_controls: false,
  loop: false,
  muted: false,
  full_width: false
};
exports.DefaultHubLVideoParams = DefaultHubLVideoParams;
var SupportedHubLVideoParams = ['hide_playlist', 'width', 'height', 'viral_sharing', 'embed_button', 'type', 'player_id', 'overrideable', 'style', 'color', 'playlist_color', 'play_button_color', 'conversion_asset', 'autoplay', 'hidden_controls', 'loop', 'muted', 'full_width'];
exports.SupportedHubLVideoParams = SupportedHubLVideoParams;
var VIDEO_DESCRIPTION_MAX_LENGTH = 5000;
exports.VIDEO_DESCRIPTION_MAX_LENGTH = VIDEO_DESCRIPTION_MAX_LENGTH;
var VIDEO_FILE_NAME_MAX_LENGTH = 70;
exports.VIDEO_FILE_NAME_MAX_LENGTH = VIDEO_FILE_NAME_MAX_LENGTH;